import { useCallback, useEffect, useMemo } from "react";

import { useQuery } from "hooks";

function useCheckAdvisorEmailExist(variables) {
  const queryFactory = useCallback(() => {
    const query = `query advisorEmail($advisorEmail: String!) {
      advisorEmailExist(advisorEmail: $advisorEmail)
    }`;

    const resolver = (resp) => {
      return resp;
    };

    return { query, resolver };
  }, []);

  const { loading, data, errors, reloadData } = useQuery(queryFactory, {
    variables: variables,
    options: { fetchOnInit: false, refetchOnVarChange: false, cached: true },
  });

  const emailExists = useMemo(() => {
    return Boolean(data?.data?.advisorEmailExist);
  }, [data]);

  useEffect(() => {
    if (variables?.advisorEmail) reloadData();
  }, [variables, reloadData]);

  return {
    emailExists,
    loading,
    errors,
    reloadData,
  };
}

export default useCheckAdvisorEmailExist;
